import { LoadingScreen } from './Screen'

export const Loading = {
  Screen: LoadingScreen,
  Spinner: {},
}
